import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/ui/select'
import { cn } from '@/lib/utils'
import { useNavigate } from '@tanstack/react-router'
import { useOrganizationId } from '../../hooks/use-organization-id'

export type OrganizationId = 7 | 90

export const DEFAULT_ORGANIZATION_ID: OrganizationId = 7

const channelLabels: Record<OrganizationId, string> = {
    7: 'Chat',
    90: 'Mail',
}

const organizationIds: OrganizationId[] = [7, 90]

interface ChannelFilterProps {
    className?: string
}

export function ChannelFilter({ className }: ChannelFilterProps) {
    const navigate = useNavigate()
    const organizationId = useOrganizationId()
    const orgId = organizationId as OrganizationId
    
    const handleValueChange = (val: string) => {
        const newOrgId = Number(val) as OrganizationId
        navigate({
            to: '/playbook',
            search: {
                organizationId: newOrgId,
            },
            replace: true,
        })
    }
    
    return (
        <Select value={String(organizationId)} onValueChange={handleValueChange}>
            <SelectTrigger
                className={cn(
                    'h-auto gap-1.5 rounded-lg border border-border bg-background px-1.5 py-0.5 shadow-sm',
                    'focus:ring-1 focus:ring-ring',
                    className
                )}
            >
                <div className="flex items-center gap-1.5">
                    <span className="text-sm text-muted-foreground">Channel:</span>
                    <SelectValue placeholder="Select channel">
                        {channelLabels[orgId]}
                    </SelectValue>
                </div>
            </SelectTrigger>
            <SelectContent>
                {organizationIds.map((orgId) => (
                    <SelectItem key={orgId} value={String(orgId)}>
                        {channelLabels[orgId]}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
